<template>
  <ul class="formats__list">
    <li class="formats__item demo__item" :class="'demo-item-'+index" v-for="(item,index) in demoSections">
      <demo-item :title="item.title" :adformat="adformat"></demo-item>
    </li>
  </ul>
</template>

<script>
  import DemoItem from './DemoItem.vue'

  export default {
    name: 'demo-listing',
    props: ['adformat'],
    components: {
      demoItem: DemoItem
    },
    data () {
      return {
        demoSections: [
          {title: 'Description'},
          {title: 'Available Sizes'},
          {title: 'Media Kit Material'},
          {title: 'Design Information'}
        ]
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/demo/DemoListing.vue